export const frenchTranslations = {
  // Meta & General
  pageTitle: "Vidéos marketing avec IA pour entreprises | Future Level Suisse",
  pageDescription: "Créez des vidéos marketing avec l'intelligence artificielle – Future Level réduit les coûts et améliore votre visibilité en ligne.",
  
  // Navigation
  home: "Accueil",
  services: "Services",
  whyFutureLevel: "Pourquoi Future Level?",
  blog: "Blog",
  contact: "Contact",
  breadcrumbNavigation: "Fil d'Ariane",
  
  // Pricing Page
  pricing: "Tarifs",
  pricingSubtitle: "Tarification transparente pour la production vidéo IA avec le meilleur rapport qualité-prix",
  pricingDescription: "Découvrez nos modèles de prix transparents pour la production vidéo basée sur l'IA : Des vidéos uniques aux abonnements mensuels.",
  
  // Service Names
  productVideos: "Vidéos de Produits",
  kiVideoProductShowcase: "Vidéos de Produits IA",
  explainerVideos: "Vidéos Explicatives",
  socialMediaAds: "Publicités pour Médias Sociaux",
  reels: "Reels",
  
  // Service Descriptions
  productVideosDesc: "Présentez vos produits sous leur meilleur jour – automatiquement, rapidement, de manière convaincante.",
  explainerVideosDesc: "Contenu complexe expliqué simplement et de manière compréhensible par l'IA.",
  socialMediaAdsDesc: "Vidéos courtes haute performance pour vos campagnes sur Instagram, Facebook, TikTok et plus.",
  reelsDesc: "Portée maximale grâce aux reels IA tendance à votre image de marque.",
  
  // Hero Section
  heroTitle: "Marketing Vidéo Orienté vers l'Avenir avec l'IA",
  heroSubtitle: "Économisez du temps et des coûts, maximisez l'impact",
  contactUs: "Contactez-nous",
  learnMore: "En savoir plus",
  
  // Why Future Level
  whyFutureLevelSubtitle: "Notre technologie d'IA crée des vidéos plus rapidement que n'importe quelle agence – sans acteurs, caméras ou production en studio.",
  costSaving: "Économie de Coûts",
  timeSaving: "Gain de Temps",
  increaseSales: "Augmentation des Ventes",
  targetAudience: "Adapté à Votre Public Cible",
  costSavingDesc: "Réduisez vos coûts de production jusqu'à 70% par rapport aux productions vidéo conventionnelles.",
  timeSavingDesc: "Recevez vos vidéos finies en quelques jours au lieu de semaines ou de mois.",
  increaseSalesDesc: "Augmentez votre taux de conversion et vos ventes grâce à un contenu visuel convaincant.",
  targetAudienceDesc: "Chaque vidéo est précisément adaptée à votre public cible et à votre secteur.",
  
  // Why AI Videos Section
  whyKIVideosTitle: "Vidéos AI pour médias sociaux: 300% plus d'engagement et 70% d'économie",
  whyKIVideosPoint1: "Équipe d'experts utilisant des outils d'IA avancés pour les vidéos Instagram, TikTok et Facebook - toujours à la pointe de la technologie",
  whyKIVideosPoint2: "Équipe composée exclusivement d'éditeurs vidéo professionnels avec des années d'expérience en production vidéo numérique",
  whyKIVideosPoint3: "Concentration totale sur votre succès grâce à des stratégies vidéo personnalisées basées sur l'IA",
  whyKIVideosPoint4: "Équipe professionnelle avec expertise dans tous les formats de médias sociaux (Instagram Reels, Facebook Ads, TikTok)",
  
  // Services Section
  ourServices: "Nos Services",
  servicesSubtitle: "Des vidéos marketing professionnelles basées sur l'IA qui transmettent efficacement votre message.",
  
  // Testimonials
  clientTestimonials: "Témoignages Clients",
  testimonialsSubtitle: "Ce que disent nos clients à propos de nous",
  testimonial1: "Les vidéos IA de Future Level ont augmenté le taux de conversion dans notre boutique en ligne de 35%. Un rapport qualité-prix incroyable!",
  testimonial2: "Nous utilisons les vidéos explicatives pour des sujets de conseil complexes. Nos clients sont ravis de la clarté du contenu.",
  testimonial3: "Les publicités sur les médias sociaux ont aidé notre clinique à atteindre une notoriété locale nettement plus élevée. Le ROI est impressionnant.",
  
  // Blog Section
  latestBlogPosts: "Derniers Articles de Blog",
  blogSubtitle: "Tendances et conseils sur le marketing vidéo et l'IA dans le marketing",
  blogTitle1: "Tendances du Marketing Vidéo 2025",
  blogExcerpt1: "Quels formats vidéo et technologies dominent le marketing cette année? Aperçus et prévisions.",
  blogTitle2: "L'IA dans le Marketing - Révolution ou Engouement?",
  blogExcerpt2: "Comment l'intelligence artificielle change durablement le marketing et quelles opportunités s'offrent aux entreprises.",
  blogTitle3: "Étude de Cas: Campagnes Vidéo Réussies",
  blogExcerpt3: "Analyse de trois campagnes vidéo particulièrement réussies et ce que vous pouvez en apprendre.",
  readMore: "Lire la Suite",
  viewAllPosts: "Voir Tous les Articles",
  
  // Blog Page
  blogPageTitle: "Connaissances d'Experts: Marketing Vidéo & IA",
  blogPageSubtitle: "Tendances actuelles, conseils pratiques et histoires de réussite du monde du marketing vidéo basé sur l'IA",
  blogMetaDescription: "Le blog Future Level propose des connaissances d'experts sur le marketing vidéo IA, les tendances et les meilleures pratiques pour les entreprises en Suisse.",
  backToBlog: "Retour au Blog",
  blogContentPlaceholder: "Cette section contient des informations détaillées sur le sujet. Sur un site web en direct, le contenu complet de l'article serait ici.",
  blogSubheading1: "Principaux Enseignements",
  blogSubheading2: "Applications Pratiques",
  blogSubheading3: "Conclusion et Perspectives",
  blogCTA: "Souhaitez-vous en savoir plus sur nos solutions vidéo IA?",
  
  // Contact Form
  contactSubtitle: "Prêt à révolutionner votre stratégie de marketing vidéo avec l'IA? Remplissez notre formulaire de contact – nous vous répondrons dans les 24 heures.",
  fullName: "Nom Complet",
  email: "E-mail",
  company: "Entreprise",
  phone: "Numéro de Téléphone",
  projectDescription: "Description du Projet",
  send: "Envoyer",
  formSubmitSuccess: "Message Envoyé!",
  formSubmitMessage: "Merci pour votre demande. Nous vous contacterons dans les 24 heures.",
  
  // Clients Section
  trustedBy: "Ces Entreprises Nous Font Confiance",
  
  // Legal Page
  tableOfContents: "Table des matières",
  legalTitle: "Mentions Légales",
  legalDescription: "Détails de l'entreprise et informations juridiques sur notre agence de marketing vidéo IA à Emmen, Suisse",
  contactInfo: "Coordonnées",
  companyDetails: "Détails de l'entreprise",
  vatInfo: "Informations TVA",
  authorizedRepresentative: "Représentant autorisé",
  legalNotices: "Avis juridiques",
  disclaimer: "Clause de non-responsabilité",
  copyright: "Droits d'auteur",
  lastUpdated: "Dernière mise à jour: Mai 2025",
  backToTop: "Retour en haut",
  collapseTOC: "Réduire la table des matières",
  expandTOC: "Développer la table des matières",
  navigateToSection: "Naviguer vers la section",
  
  // Footer
  footerDescription: "Future Level - Votre partenaire pour les vidéos marketing basées sur l'IA en Suisse. Boostez votre succès avec des solutions vidéo innovantes.",
  quickLinks: "Liens Rapides",
  allRightsReserved: "Tous droits réservés.",
  impressum: "Mentions Légales",
  privacy: "Politique de Confidentialité",
  terms: "Conditions Générales"
};
